export default "__VITE_ASSET__1bzIikD$__"